<template>
  <div class="content md">
    <data-list
      ref="dataList"
      style="height: 100%"
      url="/admin/record-survey"
      entity-name="满意度"
      :query="`&filter[type]=${type}`"
      :add-btn="false"
      hide-edit
      :deal-list="dealList"
      :action="action"
      :columns="columns"
      :request-config="{ noTempleFilter: true }"
      :action-width="120"
      @detail="showDetail"
    >
      <template v-slot:query="{ form }">
        <a-form-model-item label="">
          <a-input-search v-model="form.name" placeholder="输入姓名查询"></a-input-search>
        </a-form-model-item>
      </template>
      <template v-slot:panel>
        <div class="panel-box flex-box align-center">
          <chart :option="satisfactionOption" class="chart-box" />
          <vue-qr :text="qrcode" :margin="8" :size="166" class="qrcode" />
        </div>
      </template>
    </data-list>
    <a-modal title="调查详情" :width="640" :footer="null" v-model="visible">
      <detail-list label-width="200px" :list="detailList"></detail-list>
    </a-modal>
  </div>
</template>

<script>
import {
  getSatisfactionOptionScore,
  getSatisfactionOptionText,
  satisfactionTypeOptions,
} from "@/views/program/data/satisfaction";
import DetailList from "@/layouts/DetailList.vue";
import { getSatisfactionPieChartOption } from "../department/constant";
import VueQr from "vue-qr";
import { getTemple } from "@/common/js/storage";

export default {
  name: "Satisfaction",
  components: { DetailList, VueQr },
  data() {
    return {
      columns: [
        { title: "填写时间", dataIndex: "create_time" },
        { title: "个人评分", dataIndex: "rate" },
      ],
      visible: false,
      detailList: [],
      satisfactionTypeOptions,
      info: null,
      satisfactionOption: {},
    };
  },
  props: {
    type: { required: true, type: Number },
    qrcode: { required: true, type: String },
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    updateList() {
      this.$refs.dataList.updateList();
    },
    getData() {
      let params = { type: this.type };
      let temple = getTemple();
      if (temple) {
        params.temple_id = temple;
      }
      this.$axios({
        url: "/admin/record-survey/statistics",
        method: "GET",
        params,
        noTempleFilter: true,
      }).then((res) => {
        this.info = res.data;
        this.getSatisfactionChart();
      });
    },
    showDetail({ item }) {
      if (!item.detaiList) {
        item.detaiList = [
          { label: "提交时间", key: "create_time", value: item.create_time, full: true },
          { label: "信众名字", key: "name", value: item.name, full: true },
          { label: "地址", key: "location", value: item.location, full: true },
          { label: "联系电话", key: "mobile", value: item.mobile, full: true },
          ...item.scoreList.map((s, index) => {
            return {
              label: s.label,
              key: `rate_${index}`,
              value: getSatisfactionOptionText(s.value),
              full: true,
            };
          }),
          { label: "个人评分", key: "rate", value: item.rate, full: true },
        ];
      }
      this.detailList = item.detaiList;
      this.visible = true;
    },
    dealList(list, fn) {
      list.forEach((item) => {
        let rate = 0;
        let scoreList = [];
        if (item.score) {
          try {
            scoreList = JSON.parse(item.score);
            rate = scoreList.reduce((acc, val) => acc + getSatisfactionOptionScore(val.value), 0);
            rate = Math.round((rate / 9) * 100) / 100;
          } catch (e) {
            console.error(e);
          }
        }
        item.scoreList = scoreList;
        item.rate = rate;
      });
      fn();
    },
    getSatisfactionChart() {
      const info = this.info;
      const data = [
        { name: "满意", value: info?.very_satisfied || 0 },
        { name: "较满意", value: info?.satisfied || 0 },
        { name: "一般", value: info?.average || 0 },
        { name: "不满意", value: info?.unsatisfied || 0 },
      ];
      this.satisfactionOption = getSatisfactionPieChartOption(data, 80);
    },
  },
};
</script>

<style lang="less" scoped>
.panel-box {
  height: 204px;
  padding: 12px;
}
.chart-box {
  width: 260px;
  height: 100%;
}
.qrcode {
  margin-left: 24px;
}
</style>
